/* eslint-disable react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HomeIcon from "@mui/icons-material/Home";
import MoneyIcon from "@mui/icons-material/Money";
import RefreshIcon from "@mui/icons-material/Refresh";
import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import { StringUtils } from "../../../utils/StringUtils";
import CustomerAcctpaymentTypeSelector from "./CustomerAcctpaymentTypeSelector";
import CustomerAccountingCrud2 from "./CustomerAccountingCrud2";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function AccountingList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [searchStr, setSearchStr] = useState("");
  const [selectedRowFromGrid, setSelectedRowFromGrid] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [transactionMode, setTransactionMode] = useState("");
  const [showCrud, setShowCrud] = useState(false);
  const [mode, setMode] = useState("");
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 155) / 32)
  );

  useEffect(() => {
    loadData();
  }, []);

  // function addCashTransactions() {
  //   let transactionMode = "Cash";
  //   biRef.child.showCustomerAccountingCrudWindow(transactionMode, null);
  // }

  function addCashTransactions() {
    let transactionMode = "Cash";
    biRef.child.showCustomerAccountingPaymentType(transactionMode, null);
  }

  function onViewButtonClicked(row) {
    setSelectedRowFromGrid(row.tableData[row.rowIndex].id);
    setTransactionMode(row.tableData[row.rowIndex].transactionMode);
    setShowCrud(true);
    setMode("view");
    switch (row.tableData[row.rowIndex].paymentType) {
      case "1":
        setPaymentType({ id: 1, name: "Invoice against" });
        break;
      case "2":
        setPaymentType({ id: 2, name: "Own account" });
        break;
      case "3":
        setPaymentType({ id: 3, name: "Advance receipt" });
        break;
      case "4":
        setPaymentType({ id: 4, name: "Partial receipt" });
        break;
    }
  }

  function addBankTransactions() {
    let transactionMode = "Bank";
    biRef.child.showCustomerAccountingPaymentType(transactionMode, null);
  }

  function addTransactions() {
    biRef.child.showCustomerAccountingCrudWindow(null, null);
  }

  function onPrintClicked(row) {
    let paramsList = [
      {
        key: "accountingTransactionId",
        value: row.tableData[row.rowIndex].id,
      },
    ];

    biRef.genericReportView.showGenericReportViewer(
      "reports/generic/customer_receipt_voucher",
      paramsList,
      "Customer Transaction",
      "v2"
    );
  }

  async function loadData() {
    loadByRest(0, rowLimitPerPage, "[]", "[]");
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(false);
    sort = '[{id:"transactionDate2",desc:true}]';
    const result = await API.get(
      "/api/v1/getacctransactions/CUSTOMER?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);
  }

  async function loaadByDB() {
    db.transactions.toArray(function (data) {
      setData(data);
    });
  }

  async function onTableChange(tableState) {
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"fromLedgerName",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"toLedgerName",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"voucherNumber",value:"' + tableState.searchText + '"}';

      str = str + "]";
      search = str;
    }
    loadByRest(tableState.page, tableState.rowsPerPage, sort, search);
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    download: false,
    viewColumns: false,
    filter: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: getWindowDimensions().height - 162,
    rowsPerPage: Math.round((getWindowDimensions().height - 162) / 33),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 162) / 33),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="secondary"
              onClick={transactionsListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title={translate("Add Cash Transaction")}>
            <Button color="primary" onClick={addCashTransactions}>
              <MoneyIcon />
              Cash<sup>+</sup>
            </Button>
          </Tooltip>

          <Tooltip title={translate("Add Bank Transaction")}>
            <Button color="secondary" onClick={addBankTransactions}>
              <AccountBalanceIcon />
              Bank<sup>+</sup>
            </Button>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  function getPaymentType(value) {
    let type = "";
    if (value === "1") {
      type = "Full";
    } else if (value === "2") {
      type = "Partial";
    } else if (value === "4") {
      type = "Manual";
    } else {
      type = "Advance";
    }

    return type;
  }

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "voucherNumber",
      label: translate("Voucher Number"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "transactionDate2",
      label: translate("Date"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "paymentType",
      label: translate("Type"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return getPaymentType(value);
        },
      },
    },
    {
      name: "fromLedger",
      label: translate("From"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.name;
        },
      },
    },
    {
      name: "toLedger",
      label: translate("To"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.name;
        },
      },
    },

    {
      name: "amount",
      label: translate("Amount"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value < 0 ? (
            <div>
              {StringUtils.formattedNumber(
                value * -1,
                props.context.store.currencyDecimal
              )}
            </div>
          ) : (
            <div>
              {StringUtils.formattedNumber(
                value * 1,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
    {
      name: "discount",
      label: translate("Discount"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "actualAmount",
      label: translate("Actual Amount"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            {tableMeta.tableData[tableMeta.rowIndex]
              .accountingTransactionItemList && (
              <div>
                <Button
                  onClick={() =>
                    onViewButtonClicked(tableMeta, updateValue, value)
                  }
                  color="secondary"
                  style={{
                    margin: 0,
                    padding: 0,
                    height: 17,
                    width: 27,
                    alignText: "right",
                  }}
                >
                  {translate("View")}
                </Button>
                <Button
                  onClick={() => onPrintClicked(tableMeta, updateValue, value)}
                  color="secondary"
                  style={{
                    margin: 0,
                    padding: 0,
                    height: 17,
                    width: 27,
                    alignText: "right",
                  }}
                >
                  {translate("Print")}
                </Button>
              </div>
            )}
          </div>
        ),
      },
    },
  ];

  function transactionsListRefresh() {
    loadData();
  }
  var biRef = {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {"Customer Transaction List"}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
      ></GenericReportViewer>
      <CustomerAcctpaymentTypeSelector
        biRef={biRef}
        type={props.type}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        onRefresh={transactionsListRefresh}
        showProgress={props.showProgress}
        hideProgress={props.hideProgress}
      ></CustomerAcctpaymentTypeSelector>
      {showCrud && (
        <CustomerAccountingCrud2
          selectedRowFromGrid={selectedRowFromGrid}
          showCrud={props.showCrud}
          transactionMode={transactionMode}
          paymentType={paymentType}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
          setShowCrud={setShowCrud}
          // onRefresh={props.onRefresh}
          onRefresh={transactionsListRefresh}
          showProgress={props.showProgress}
          mode={mode}
          hideProgress={props.hideProgress}
        ></CustomerAccountingCrud2>
      )}
    </Grid>
  );
}
